/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  REBATE_SELECT,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  autoFormateDate,
  tabHighLigther,
  validateDate,
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getManufacturerList,
  // getResultGridChipCshcnRates,
  setChipCshcnReport,
  getChipCshcnRatesMaxQtr,
  getResultGridChipCshcnRateAudit,
} from '../Store/actions';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqChipCshcnRateAudit(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    rebateProgramNameValue,
    manufacturerList: resultanufacturerList,
    selectedRowIndexValue,
    searchResult,
    chipCshcnMaxQuarter,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      quarterValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      scrollDownManufacturers: scrollDownManufacturersValue,
    },
  } = useSelector((state) => state?.sharedState?.ChipCshcnRateAuditReducer);
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [quarter, setQuarter] = useState(quarterValue);
  const [radioList, setRadioList] = useState([]);
  const [planType, setPlanType] = useState(selectedPlanType);
  const [selectList, setSelectList] = useState([]);
  const [rebateProgram, setRebateProgram] = useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = useState(
    rebateProgramNameValue
  );
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] = useState(
    isAllManufacturersSelectedValue
  );
  const [scrollDownManufacturers, setScrollDownManufacturers] = useState(
    scrollDownManufacturersValue
  );
  const [manufacturerSelected, setManufacturerSelected] = useState(['ALL']);
  const [manufacturerList, setManufacturerList] = useState([]);
  const [errorList, setErrorList] = useState(errors);
  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = useState(false);
  const [fullScreenView, setfullScreenView] = useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  const [selectedRowIndex, setSelectedRowIndex] = useState(
    selectedRowIndexValue
  );

  // For No Data validation
  // React.useEffect(() => {
  //   setErrorList(errors);
  // }, [errors]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });

      // Filter out the 'FD' option
      const filteredPlanList = planList.filter((obj) => obj.value !== 'FD');

      setRadioList([
        ...filteredPlanList.filter((obj) => obj.value === 'ST'),
        ...filteredPlanList.filter((obj) => obj.value === 'SUPP'),
        ...filteredPlanList.filter((obj) => obj.value === 'COMM'),
      ]);

      const tempPlanType = filteredPlanList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      if (!planType || planType === 'FD') {
        if (userDefaults?.planTypeCd === 'FD' || !tempPlanType) {
          // Set default plan type, ensuring it is not 'FD'
          setPlanType(null); // No radio button selected
          setRebateProgram('-1');
          setRebateProgramName('');
        } else {
          setPlanType(planType || tempPlanType?.value);
        }
      }
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // Calling API to get the Max Quarter
  React.useEffect(() => {
    dispatch(getChipCshcnRatesMaxQtr());
  }, []);

  // To set the quarter varaible
  React.useEffect(() => {
    if (chipCshcnMaxQuarter) {
      setQuarter(quarterValue || chipCshcnMaxQuarter);
    }
  }, [chipCshcnMaxQuarter]);

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    // dispatch(setSearchInput({ errorMessages: [] }));
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr',true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    setErrorList(localErrors);
  };

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    // dispatch(setSearchInput({ errorMessages: [] }));
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    // dispatch(setSearchInput({ errorMessages: [] }));
    const manuError = [];
    const selectedRows = e.api?.getSelectedRows();
    if (selectedRows?.length > 0) {
      setManufacturerSelected([selectedRows[0]?.mfgId]);
    } else {
      setManufacturerSelected({});
    }
    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    let selectedIndexes = '';
    manufacturerList.forEach((item, index) => {
      if (selectedMfgId?.indexOf(item.mfgId) != -1) {
        selectedIndexes = index;
      }
    });

    setSelectedRowIndex(selectedIndexes);
    setErrorList(manuError);
  };

  const cellClickedListener = (e) => {
    // dispatch(setSearchInput({ errorMessages: [] }));
    setManufacturerSelected([e?.data]);
    handleSearchClick(null, true, [e?.data]);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = (
    e,
    onDoubleClick = false,
    selectedRowOnDoubleClick = []
  ) => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (!onDoubleClick && manufacturerSelected.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }
    if (onDoubleClick && selectedRowOnDoubleClick.length === 0) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    allErrors = [...allErrors, ...errorList];

    setErrorList(allErrors);

    let tempIndexes = '';
    if (onDoubleClick) {
      manufacturerList.forEach((item, index) => {
        if (
          selectedRowOnDoubleClick &&
          selectedRowOnDoubleClick[0]?.mfgId === item?.mfgId
        ) {
          tempIndexes = index;
        }
      });
    }

    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        rebateProgrameName,
        manufacturerSelected: onDoubleClick
          ? selectedRowOnDoubleClick
          : manufacturerSelected,
        quarterValue: quarter,
        isAllManufacturersSelected,
        selectedRowIndexValue: onDoubleClick ? tempIndexes : selectedRowIndex,
        scrollDownManufacturers,
        searchScreenVar: {
          rebateProgramValue: rebateProgram,
          selectedPlanType: planType,
          quarterValue: quarter,
          isAllManufacturersSelected,
          scrollDownManufacturers,
          rebateProgrameName,
        },
      })
    );

    if (allErrors.length === 0) {
      dispatch(setChipCshcnReport([]));
      setSearchClicked(true);
      dispatch(
        getResultGridChipCshcnRateAudit({
          calcQtr: quarter,
          mfgId: onDoubleClick
            ? [selectedRowOnDoubleClick[0]?.mfgId]
            : manufacturerSelected,
          aiAll: manufacturerSelected[0] === 'ALL' ? 1 : 0,
          rebateProgramCd: rebateProgram,
        })
      );
    }

    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);
        
  //remove no data error msg
  // React.useEffect(() => {
  //   console.log('================rebateProgramNameValue req11====================')
  //   dispatch(setSearchInput({ errorMessages: [] }));
  // }, []);
  
  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispChipCshcnRateAudit',
      value: 'Display CHIP CSHCN Rate Audits',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/dispChipCshcnRateAudit',
      });
    }
    dispatch(clearReduxForFilterAndSort('/dispChipCshcnRateAudit'));
  }

  // const errorElem = document.getElementById('errorScroll');
  // if (errorElem && errorList.length > 0) {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // }

 // Clear the toast error
    React.useEffect(() => {
      dispatch(setSearchInput({ errors: [] }));
    }, [
      rebateProgram,
      radioList,
      rebateProgramName,
      planType,
      quarter,
    ]);

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  const [gridApi, setGridApi] = React.useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  React.useEffect(() => {
    if (!gridApi || manufacturerList === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
      onSelectionChanged({ api: gridApi });
    }
  }, [gridApi, manufacturerList]);
  return (
    <div className="tabs-container">
      {!fullScreenView && (
        <div className="tab-body">
          <Spinner load={isLoading} />
          {/* <div id="errorScroll"> */}
          <DisplayErrorMessages
            errorMessages={[...new Set(errorMessages.map((l) => l))]}
          />
          {/* </div> */}
          <CustomSeparator
            parent1="State Reports"
            parent2="CHIP/CSHCN Rate Audit"
          />
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="chip-chscn-plan-by-radio-btn-plan"
                id="filter-plan-by-radio-btn-action"
                labelName="Plan Type"
                required={false}
                optionList={radioList || []}
                defaultValue={planType}
                filterAction={(value) => {
                  setPlanType(value);
                  setRebateProgram('-1');
                  handleOnChangeEvent(value, 'planTypeCd');
                  const errors = errorList.filter(
                    (error) => error.field !== 'rebateProgram'
                  );
                  setErrorList([...errors]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <>
                <Fieldset label="Rebate Program" required>
                  <div>
                    <SelectBoxComponent
                      data-testid="chip-cshcn-Rebate-Program"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        setRebateProgramName(value);
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </>
            </div>
            <div className="col-3 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  label="Quarter"
                  id="Quarter"
                  data-testid="req-NDC-payment-quarter"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 6 }}
                  required
                  name="qtr"
                  value={quarter}
                  error={
                    errorList.filter((error) => error.field === 'qtr')?.length >
                    0
                      ? 'mandate-fields'
                      : ''
                  }
                  helperText={
                    errorList.find((error) => error.field === 'qtr')?.message
                  }
                  className="mandate-fields"
                  onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                  onChange={(e) => {
                    const { value } = e.target;
                    setQuarter(value.toUpperCase());
                    const localErrors = errorList.filter(
                      (error) => error.field != 'qtr'
                    );
                    setErrorList(localErrors);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row ml-2 mt-3">
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onChange={async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );
                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected(['ALL']);
                      } else {
                        setManufacturerSelected([]);
                      }
                      const elem = document.getElementById('abc11');
                      if (elem && scrollDownManufacturers) {
                        await Promise.resolve();
                        // setTimeout(() => {
                          elem.scrollIntoView();
                        // }, 1000);
                      }
                      const errors = errorList.filter(
                        (error) => error.field !== 'manufacturer'
                      );
                      setErrorList([...errors]);
                      dispatch(setSearchInput({ errors: [] }));

                    }}
                    isError={
                      errorList.find((error) => error.field === 'manufacturer')
                        ?.message
                    }
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row" style={{ marginTop: 15 }}>
            <div className="btn-wrapper col-12">
              <Button
                onClick={handleSearchClick}
                className="btn btn-success btn-search float-right"
              >
                <SVGComponent iconName="Icon-search" /> Search
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              selectRowIndex={selectedRowIndexValue}
              cellClickedListener={cellClickedListener}
              rowData={manufacturerList || []}
              gridCall={onGridReady}
              helpMessage
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              rowSelection="single"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
      </div>
    </div>
  );
}
